import { render, staticRenderFns } from "./antiBrush.vue?vue&type=template&id=117e3ba0&scoped=true"
import script from "./antiBrush.vue?vue&type=script&lang=js"
export * from "./antiBrush.vue?vue&type=script&lang=js"
import style0 from "./antiBrush.vue?vue&type=style&index=0&id=117e3ba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e3ba0",
  null
  
)

export default component.exports